<!-- template is directly on the cshtml page type 'ModelOverviewPage' -->
<script>
import _ from 'lodash';
import axios from 'axios';
import ModelOverviewFilterPanel from './ModelOverviewFilterPanel.vue';
import ModelOverviewTableContainer from './ModelOverviewTableContainer.vue';
import { enableSpinner, disableSpinner } from '../js/spinner.js';
import formatMixin from '../mixins/formatter.js';

export default {
    name: 'model-overview',
    mixins: [formatMixin],
    template: '#model-overview-page',
    props: {
        brandCarModelLists: Array
    },
    data() {
        return {
            tableData: this.brandCarModelLists,
            selectedBrands: [],
            selectedModels: [],
            selectedPropellants: [],
            //selectedCO2: undefined,
            selectedCO2: [],
            selectedTaxBase: [],
            selectedTowing: [],
            isInitialized: false
        }
    },
    computed: {
        brandOptions: function () {
            if (this.tableData) {
                return this.tableData
                    .map(b => ({ text: this.formatBrand(b.brand), value: b.brand }))
                    .sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' }));
            }

            return undefined;
        },
        modelOptions: function () {
            let vm = this;
            if (this.tableData) {
                let modelOptions = this.tableData.map(table => {
                    if (vm.selectedBrands.includes(table.brand) || vm.selectedBrands.length == 0) {
                        let uniqueCarModels = _.uniqBy(table.carModels, carModel => carModel.id);
                        let options = uniqueCarModels.map(carmodel => ({ text: carmodel.modelName, value: carmodel.modelName }));

                        return ({ brand: table.brand, modelOptions: options });
                    }
                });

                //remove undefined objects
                return modelOptions.filter(option => option !== undefined);
            }

            return undefined;
        },
        propellantOptions: function () {
            let vm = this;
            if (this.tableData) {
                let allCarModels = _.flatMap(this.tableData, table => table.carModels);
                let allProppellant = _.flatMap(allCarModels, carmodel => carmodel.propellantAvailable);
                let allProppellantTypes = allProppellant.map(propellant => ({ text: vm.setPropellantText(propellant), value: propellant }))

                return _.uniqBy(allProppellantTypes, propellantType => propellantType.value);
            }

            return undefined;
        },
        taxBaseRange: function () {
            if (this.tableData) {
                let allCarModels = _.flatMap(this.tableData, table => table.carModels);
                let allTaxBase = allCarModels.map(carmodel => carmodel.taxBase);

                let min = _.min(allTaxBase);
                let max = _.max(allTaxBase);

                //round to nearest 10.000
                min = _.floor(min, -4);
                max = _.ceil(max, -4);

                return { min: min, max: max };
            }

            return undefined;
        },
        co2Range: function () {
            if (this.tableData) {
                let allCarModels = _.flatMap(this.tableData, table => table.carModels);
                let allCo2 = _.flatMap(allCarModels, carmodel => carmodel.co2Range);

                let min = _.min(allCo2);
                let max = _.max(allCo2);

                return { min: min, max: max };
            }

            return undefined;
        },
        towingRange: function () {
            if (this.tableData) {
                let allCarModels = _.flatMap(this.tableData, table => table.carModels);
                let allTowing = _.flatMap(allCarModels, carmodel => carmodel.maxTowingCapacity)

                let min = _.min(allTowing);
                let max = _.max(allTowing);

                return { min: min, max: max };
            }
        },
        filteredTableData: function () {
            let vm = this;
            if (this.tableData) {
                let newTableData = this.tableData;

                //filter by selected brands
                if (this.selectedBrands.length > 0) {
                    newTableData = newTableData.filter(table => {
                        return vm.selectedBrands.includes(table.brand);
                    });
                }

                //filter by selected models
                if (this.selectedModels.length > 0) {
                    newTableData = newTableData.map(table => (
                        {
                            brand: table.brand,
                            carModels: table.carModels.filter(carModel => vm.selectedModels.includes(carModel.modelName))
                        }));
                }

                //filter by propellant
                if (this.selectedPropellants.length > 0) {
                    newTableData = newTableData.map(table => (
                        {
                            brand: table.brand,
                            carModels: table.carModels.filter(carModel => vm.isPropellantAvailable(carModel.propellantAvailable))
                        }));
                }

                //filter by taxbase
                if (this.selectedTaxBase.length > 0) {
                    newTableData = newTableData.map(table => (
                        {
                            brand: table.brand,
                            carModels: table.carModels.filter(carModel => carModel.taxBase >= vm.selectedTaxBase[0] && carModel.taxBase <= vm.selectedTaxBase[1])
                        }));
                }

                //filter by co2
                if (this.selectedCO2.length > 0) {
                    newTableData = newTableData.map(table => (
                        {
                            brand: table.brand,
                            carModels: table.carModels.filter(carModel => vm.isCo2InSelectedRange(carModel.co2Range))
                        }));
                }

                if (this.selectedTowing.length > 0) {
                    newTableData = newTableData.map(table => ({
                        brand: table.brand,
                        carModels: table.carModels.filter(carModel => carModel.maxTowingCapacity >= vm.selectedTowing[0])
                    }));
                }

                //remove tables with no cars
                //newTableData = newTableData.filter(table => {
                //    return table.carModels.length > 0;
                //});

                return newTableData.sort((a, b) => a.brand.localeCompare(b.brand, undefined, { sensitivity: 'base' }));
            }

            return undefined;
        }
    },
    components: {
        ModelOverviewFilterPanel,
        ModelOverviewTableContainer
    },
    mounted() {
        // Use nextTick to ensure child has mounted and loaded state
        this.$nextTick(() => {
            console.log('[PARENT] Initialization complete');
            this.isInitialized = true;
        });
    },
    methods: {
        isPropellantAvailable: function (availablePropellantInCarGroup) {
            return _.intersection(this.selectedPropellants, availablePropellantInCarGroup).length > 0;
        },
        isCo2InSelectedRange: function (co2Range) {
            let min = co2Range[0];
            if (min <= this.selectedCO2) {
                return true;
            }

            return false;
        },
        setPropellantText: function (value) {
            if (value === "gasoline") {
                return "Benzin";
            } else if (value === "electric") {
                return "El";
            } else if (value === "diesel") {
                return "Diesel";
            } else if (value === "hybrid") {
                return "Hybrid";
            }

            return "unknown"
        },
        receiveSelectedBrands: function (value) {
            console.log('[PARENT] Received brands:', value);
            this.$data.selectedBrands = value;
            this.savePageState();
        },
        receiveSelectedModels: function (value) {
            console.log('[PARENT] Received models:', value);
            this.$data.selectedModels = value;
            this.savePageState();
        },
        receiveSelectedPropellants: function (value) {
            this.$data.selectedPropellants = value;
            this.savePageState();
        },
        receiveSelectedTaxBase: function (value) {
            this.$data.selectedTaxBase = value;
            this.savePageState();
        },
        receiveSelectedCo2: function (value) {
            this.$data.selectedCO2 = value;
            this.savePageState();
        },
        receiveSelectedTowing: function (value) {
            this.$data.selectedTowing = value;
            this.savePageState();
        },
        savePageState: function () {
            if (!this.isInitialized) {
                console.log('[PARENT] Skipping save - not initialized yet');
                return;
            }
            console.log('[PARENT] Saving to localStorage:', {
                brands: this.selectedBrands,
                models: this.selectedModels,
                propellants: this.selectedPropellants
            });
            localStorage.selectedBrands = this.selectedBrands.join(',');
            localStorage.selectedModels = this.selectedModels.join(',');
            localStorage.selectedPropellants = this.selectedPropellants.join(',');
            localStorage.selectedCO2 = this.selectedCO2.join(',');
            localStorage.selectedTaxBase = this.selectedTaxBase.join(',');
            localStorage.selectedTowing = this.selectedTowing.join(',');
        },
        loadPageState: function () {
            if (this.isValidState(localStorage.selectedBrands)) {
                this.selectedBrands = localStorage.selectedBrands.split(',').filter(x => x !== '');
            }
            if (this.isValidState(localStorage.selectedModels)) {
                this.selectedModels = localStorage.selectedModels.split(',').filter(x => x !== '');
            }
            if (this.isValidState(localStorage.selectedPropellants)) {
                this.selectedPropellants = localStorage.selectedPropellants.split(',').filter(x => x !== '');
            }
            if (this.isValidState(localStorage.selectedCO2)) {
                this.selectedCO2 = localStorage.selectedCO2.split(',').filter(x => x !== '').map(Number);
            }
            if (this.isValidState(localStorage.selectedTaxBase)) {
                this.selectedTaxBase = localStorage.selectedTaxBase.split(',').filter(x => x !== '').map(Number);
            }
            if (this.isValidState(localStorage.selectedTowing)) {
                this.selectedTowing = localStorage.selectedTowing.split(',').filter(x => x !== '').map(Number);
            }
        },
        isValidState: function (value) {
            if (value !== undefined && value !== '' && value !== 'undefined') {
                return true;
            }
            return false;
        },
        clearPageState: function () {
            localStorage.clear();
        }
    }
}
</script>